module.exports = ":host {\n  flex: 1; }\n"